import { BlockBlobClient } from '@azure/storage-blob';

import { useApiContext } from 'context/ApiContext';

export interface UploadFileReturn {
    file: File;
    uploadUrl: string;
}

interface AzureBlobReturn {
    uploadFile: (file: File, signal?: AbortSignal) => Promise<UploadFileReturn | null>;
}

export const useAzureBlob = (): AzureBlobReturn => {
    const { api } = useApiContext();

    const uploadFile = async (file: File, signal?: AbortSignal): Promise<UploadFileReturn | null> => {
        const { data } = await api.get('/storage-azure-sas', { params: { fileName: file.name }, signal: signal });
        const { uploadUrlBlob, sasToken } = data;

        const options = {
            blobHTTPHeaders: { blobContentType: file.type },
        };

        const blobServiceClient = new BlockBlobClient(`${uploadUrlBlob}?${sasToken}`);
        await blobServiceClient.uploadData(file, options);

        return {
            file,
            uploadUrl: uploadUrlBlob,
        };
    };

    return { uploadFile };
};
